import { ConfigProvider, Divider, Dropdown, message, Modal, Select } from "antd";
import CustomInput from "../CustomInput";
import React, { useEffect, useState } from "react";
import { validateUserAddDataForSuperAdmin } from "../../services/user-service";
import useUserStore from "../../stores/store";
import ApiService from "../../utils/ApiService";

const roleList = [
  {
    value: "Admin",
    label: "Admin",
    branches: [{
      value: "Admin",
      label: "Admin",
    },
    {
      value: "Staff",
      label: "Staff",
    },
    {
      value: "Chef",
      label: "Chef",
    },],
  },
  {
    value: "Staff",
    label: "Staff",
  },
  {
    value: "Chef",
    label: "Chef",
  },
];

function AddUserModal({ openModal, params }) {
  const { user, isLoggedIn } = useUserStore();
  
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [parentRestaurantList, setParentRestaurantList] = useState(params.allRestaurantList);
  const [restaurantList, setRestaurantList] = useState([]);
  const [position, setPosition] = useState("Select Position");
  const [parentRestaurantId, setParentRestaurantId] = useState(
    params?.parentRestaurantId || ""
  );
  const [restaurantId, setRestaurantId] = useState(params?.restaurantId || "");
  const [role, setRole] = useState("");

  useEffect(() => {
    setParentRestaurantList(params.allRestaurantList);
    
  }, [params]);

  const onSelectParentRestaurant = (val) => {
    const parentItem = parentRestaurantList.find((item) => item.value === val);
    setRestaurantId("");
    setRestaurantList(parentItem.branches);
    setParentRestaurantId(val);
  };

  const items = parentRestaurantList.map((item) => ({
    value: item.value,
    label: item.label,
  }));

  const clearFields = () => {
    setRestaurantId("")
    setParentRestaurantId("")
    setName("");
    setPhone("");
    setRole("");
  };

  const handleOk = async () => {
    const errors = validateUserAddDataForSuperAdmin({
      restaurantId,
      name,
      phone,
      role,
    });

    if (errors.length > 0) {
      message.error(errors[0]);
      return;
    }

    const res = await ApiService.ADD_RESTAURANT_USER(
      {
        restaurantId,
        name,
        countryCode: "880",
        phone: phone,
        role,
      },
      user.token.token
    );

    if (res.code !== 200) {
      message.error('Failed to create user. Please try again.');
      return;
    }
    
    params.onFinish({ showModal: false });
    clearFields();
  };

  const handleCancel = () => {
    params.onCancel();
  };

  useEffect(() => {}, []);
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      {/* start user add modal */}
      <Modal
        maskClosable={false}
        open={openModal}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col font-uregular">
          <div className="text-2xl font-ubold">Add User</div>
          <Divider />

          <div className="flex flex-col mb-[12px]">
            <div className="ml-[4px] text-sm font-uregular flex flex-row">
              <div>Restaurant List</div>
              <div className="font-ubold text-red-700 ml-[2px]">*</div>
            </div>
          {parentRestaurantList.length > 0 && (
            <Select
              className="font-uregular"
              showSearch
              value={parentRestaurantId}
              placeholder="Select restaurant name"
              onChange={onSelectParentRestaurant}
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={parentRestaurantList}
            />
          )}
          </div>

          <div className="flex flex-col mb-[12px]">
            <div className="ml-[4px] text-sm font-uregular flex flex-row">
              <div>Branch List</div>
              <div className="font-ubold text-red-700 ml-[2px]">*</div>
            </div>

            <Select
              className="font-uregular"
              value={restaurantId}
              placeholder="Select restaurant name"
              onChange={(value) => setRestaurantId(value)}
              options={restaurantList}
            />
          </div>

          {/* start user name */}
          <CustomInput
            value={name}
            setValue={setName}
            showPadding={false}
            label="User Name"
            required={true}
            placeholder="User Name"
          />
          {/* end user name */}

          {/* start user name */}
          <CustomInput
            value={phone}
            setValue={setPhone}
            showPadding={false}
            label="Phone number"
            required={true}
            placeholder="i.e.: 01601497697"
          />
          {/* end user name */}

          <div className="flex flex-col mb-[12px]">
            <div className="ml-[4px] text-sm font-uregular flex flex-row">
              <div>Role</div>
              <div className="font-ubold text-red-700 ml-[2px]">*</div>
            </div>

            <Select
              className="font-uregular"
              value={role}
              placeholder="Select restaurant name"
              onChange={(value) => setRole(value)}
              options={roleList}
            />
          </div>
        </div>
      </Modal>
      {/* end user add modal */}
    </ConfigProvider>
  );
}

export default AddUserModal;
